<emperor-button
  [uiButtonType]="uiButtonType"
  [color]="color"
  [disabled]="disabled"
  [id]="buttonId"
  (click)="click()"
  >{{ text }}</emperor-button
>
